import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AttributeOption } from '~shared/models';
import { GATrackingEventType, GaTrackingEventAction, GaTrackingEventName } from '~shared/modules/ga-tracking/constants';
import { GtmDatalayerService } from '~shared/services/gtm-datalayer.service';
import { DYSON_BRAND_SLUG } from '~app/modules/flixmedia-content/constants';
import { APP_BRAND_PLP_ROUTE, APP_BRAND_PAGE, NUMBER_5 } from '~shared/constants';

@Component({
  selector: 'app-brand-list',
  templateUrl: './brand-list.component.html',
  styleUrls: ['./brand-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrandListComponent {
  @Input() brands: Array<AttributeOption>;
  @Input() isMobile: boolean;
  @Input() limit: number; // Set 10 a default in parent component

  constructor(private gtmDatalayerService: GtmDatalayerService) {}

  get displayedBrands(): Array<AttributeOption> {
    return this.brands.slice(0, this.limit);
  }

  get allBrandsHaveLogos(): boolean {
    return this.displayedBrands.length >= NUMBER_5 && this.displayedBrands.every((brand) => !!brand.logo);
  }

  getBrandPath(brandSlug: string): string {
    return brandSlug !== DYSON_BRAND_SLUG ? `/${APP_BRAND_PLP_ROUTE}/` : `/${APP_BRAND_PAGE}/`;
  }

  initializeBrandListView(): void {
    this.gtmDatalayerService.gtagEvent({
      event: GATrackingEventType.SE_BEST_SELLING_BRANDS_VIEWED,
      GA_eventname: GaTrackingEventName.GridNavigation,
      action: GaTrackingEventAction.BEST_SELLING_BRANDS_VIEWED,
    });
  }

  onBrandClickGAEvent(brandSlug: string): void {
    this.gtmDatalayerService.gtagEvent({
      event: GATrackingEventType.SE_BEST_SELLING_BRANDS_CLICKED,
      GA_eventname: GaTrackingEventName.GridNavigation,
      action: GaTrackingEventAction.BEST_SELLING_BRANDS_CLICKED,
      label: brandSlug,
    });
  }
}
